module.exports = __webpack_public_path__ + "media/images/emblems/Wiler-204142fb86255704646fde16992713a8.png";